import React from "react";

import { AccessDenied } from "src/components/AccessDenied/AccessDenied.tsx";
import { ResourceNotFound } from "src/components/QueryError/components/ResourceNotFound/ResourceNotFound.tsx";
import axios from "axios";

import { InternalServerError } from "src/components/QueryError/components/InternalServerError/InternalServerError.tsx";
import { UnexpectedQueryError } from "src/components/QueryError/components/UnexpectedQueryError/UnexpectedError.tsx";

export const QueryError = ({
  error,
  resource,
  onReset,
}: {
  error: Error | null;
  resource: string;
  onReset?: () => void;
}) => {
  if (axios.isAxiosError(error) && error.response?.status === 403) {
    return <AccessDenied />;
  }
  if (axios.isAxiosError(error) && error.response?.status === 404) {
    return <ResourceNotFound resource={resource} />;
  }

  if (axios.isAxiosError(error) && error.response?.status === 500) {
    return <InternalServerError onReset={onReset} />;
  }

  return <UnexpectedQueryError error={error} onReset={onReset} />;
};
